import { object, string, boolean, number } from 'yup'

export const schema = object({
  worker_strategy: string().required(),
  worker_options: object({
    num_concurrent_tasks: number().min(1).required(),
  }),
  skip_system_validation: boolean().required(),
})

export const otherSettingsSchema = object({
  load_transmission: object({
    sum_reactions_validation_abs_tol: number().min(0).required(),
  }),
  loads_for_checks: object({
    decisive_positioning_of_changing_loads: boolean().required(),
    max_fields_for_all_patterns: number().integer().min(1).max(8).required(),
  }),
  shear_anchor_settings: object({
    friction_coefficient: number().min(0).max(1).required(),
  }),
  supportAreaForRips: string().oneOf(['fromRip', 'fromWall']).default('fromWall').required(),
  includeRipAppliedLoadsInTieDownAnchorUplift: boolean().required(),
})

export const projectSettingsFormSchema = otherSettingsSchema.concat(
  object({
    stiffeningSegmentStoreyAssignment: string().oneOf(['distributionMethod', 'walls']).required(),
  }),
)

const stiffeningSegmentStoreyAssignmentOptions = [
  {
    value: 'walls',
    label: 'aus Wänden ableiten (neu, empfohlen)',
  },
  {
    value: 'distributionMethod',
    label: 'aus Verteilungsmethoden ableiten (legacy, deprecated)',
  },
] as const

export { stiffeningSegmentStoreyAssignmentOptions }
